import React, { useEffect, useState } from "react";
import { X, Sparkles } from "lucide-react";
import { subscribeNewsletter } from "../lib/api";
import { toast } from "sonner";

const KEY = "bindni_exit_intent_shown_v1";

export default function ExitIntentPopup() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(KEY)) return;

    let dismissed = false;
    const onLeave = (e) => {
      if (dismissed) return;
      if (e.clientY <= 0 && e.relatedTarget == null) {
        setOpen(true);
        dismissed = true;
        sessionStorage.setItem(KEY, "1");
      }
    };
    // Mobile fallback — trigger after 45s idle
    const timer = setTimeout(() => {
      if (!dismissed) {
        setOpen(true);
        dismissed = true;
        sessionStorage.setItem(KEY, "1");
      }
    }, 45000);

    document.addEventListener("mouseout", onLeave);
    return () => { document.removeEventListener("mouseout", onLeave); clearTimeout(timer); };
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await subscribeNewsletter(email);
      toast.success(res.message);
      setOpen(false);
    } catch { toast.error("Something went wrong"); } finally { setLoading(false); }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-brand-charcoal/70 p-4" onClick={() => setOpen(false)} data-testid="exit-intent-popup">
      <div className="bg-brand-ivory max-w-md w-full grid grid-cols-1 md:grid-cols-2 overflow-hidden relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={() => setOpen(false)} aria-label="Close" className="absolute top-3 right-3 z-10 text-brand-charcoal hover:text-brand-maroon" data-testid="exit-intent-close"><X size={20} /></button>
        <div className="hidden md:block">
          <img src="https://images.pexels.com/photos/8751528/pexels-photo-8751528.jpeg" alt="" className="w-full h-full object-cover" />
        </div>
        <div className="p-8">
          <Sparkles className="text-brand-gold" size={22} strokeWidth={1.4} />
          <p className="label-tiny text-brand-gold mt-3">Wait — one royal secret</p>
          <h3 className="font-serif-brand text-3xl text-brand-charcoal mt-2 leading-tight">Enjoy 10% off your first heirloom</h3>
          <p className="text-sm text-brand-muted mt-3">Drop your email and we'll send the code straight to your inbox. No spam, promise.</p>
          <form onSubmit={submit} className="mt-5 space-y-3">
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="w-full border border-brand-gold/40 px-3 py-3 outline-none focus:border-brand-maroon bg-brand-ivory-soft" data-testid="exit-intent-email" />
            <button disabled={loading} className="btn-primary w-full" data-testid="exit-intent-submit">{loading ? "Sending…" : "Claim 10% Off"}</button>
          </form>
          <button onClick={() => setOpen(false)} className="mt-3 w-full text-xs tracking-[0.2em] uppercase text-brand-muted hover:text-brand-maroon">No thanks, I'll pay full price</button>
        </div>
      </div>
    </div>
  );
}
